import NextLogs from './api'

module.exports = NextLogs
